<info>
    <header>
        Hvor finder jeg kunde- og aftalenummer?
    </header>

    <content>
        <p class="header">Kundenummer</p>
        <p>I de fysiske breve du modtager fra Klasselotteriet, finder du dit kundenummer på første side af brevet, under
            datoen. Dit kundenummer figurerer også nederst i alle e-mails, du modtager fra Klasselotteriet.</p>

        <p class="header">Aftalenummer</p>
        <p>Dit aftalenummer til Klasselotteriet finder du på betalingsoversigten fra banken, i din netbank eller du kan
            få det oplyst i din bank.</p>

        <p>Hvis du har problemer med at finde dit kunde- eller aftalenummer, er du velkommen til at ringe til
            Spillerservice på tlf. 3342 0900 mandag-fredag kl. 9.00-18.00.</p>
    </content>
</info>
